<template>
	<router-view></router-view>
</template>

<script>
export default {
  name: 'layout',
	components: {
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.tab-top{
	.el-tabs__header{
		margin-bottom: 0;
	}
	.el-tabs__item{
		color: #409EFF;
		background: #ecf5ff;
		border: 1px solid #b3d8ff;
		border-radius: 4px;
		margin:10px 10px 0 0;
		&:last-child{
			padding-right: 20px!important;
		}
		&.is-top:nth-child(2){
			padding-left: 20px!important;
		}
		&.is-active{
			background:$mainColor;
			color: #fff;
		}
		&:hover{
			background:$mainColor;
			color: #fff;
		}
	}
	.el-tabs__active-bar{
		display: none;
	}
	.el-tabs__nav-wrap::after{
		display: none;
	}
}
.page-title{
	margin: 30px 0;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: space-between;
	.title-inner {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 25px;
	}
    .select{
      .el-select{
        width: 160px;
      }
      .el-date-editor{
        width: 300px;
      }
    }
}
.el-menu--popup-bottom-start{
    min-width: 110px;
}
 .el-menu-item:not(.is-disabled):hover{
	background:rgba(230,242,255,1);;
}
.el-menu--horizontal{
	border-top: 5px solid  #fff;
}
.el-menu--horizontal>.el-submenu .el-submenu__title{
	border-bottom: none;
	border-top: 5px solid  transparent;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
	border-bottom: none;
	border-top: 5px solid #409EFF;
}
.el-input--mini{
	margin-left: -20px;
    margin-top: -5px;
	width: 130px;
	margin-right: 50px;
}
:focus{outline: none;}

html{
	width: 100%;
	height: 100%;
	font-family: "Microsoft Yahei";
	color: #333;
}
body{
	font-size: 16px;
	background: #eff3f5;
	/* width: 100%;
	height: 100%; */
	margin: 0;
	padding: 0;
}
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,form,fieldset,input,textarea,p,blockquote,th,td {
	padding:0; margin:0;
}
table {
	border-collapse:collapse;
	border-spacing: 0;
}
address,caption,cite,code,dfn,em,th,var {
	font-weight: normal;
	font-style: normal;
}
ol,ul {
	list-style: none;
}
input[type="text"],input[type="button"],input[type="submit"],input[type="reset"],button,select {
	-webkit-appearance: none;
	vertical-align: middle;
}
select:focus,input:focus{
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  -webkit-user-modify:read-write-plaintext-only;
	outline: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #888; opacity:1;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #888;opacity:1;
}
input:-ms-input-placeholder{
    color: #888;opacity:1;
}
input::-webkit-input-placeholder{
    color: #888;opacity:1;
}
select {
  border: solid 1px #000;
  appearance:none;
  -moz-appearance:none;
  -webkit-appearance:none;
}
select::-ms-expand {
	display: none;
}
textarea {
    resize: none!important;
    font-family: "Microsoft Yahei";
}
img{
	vertical-align: middle;
	border:0;
}
a {
	border: none;
	text-decoration: none;
	color: #333;
}
.share{
	width: 26px;
	height: 26px;
	display: block;
	margin: 0 6px;
}
.share-label{
	color: #777;
}
.card{
	width: 100%;
	background: #fff;
	border-radius: 5px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	overflow: hidden;
	transition: all .5s;
}
.card .card-top{
	width: 100%;
	height: 282px;
	position: relative;
}
.card .card-top .img{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.card .card-top .img-bottom{
	width: 100%;
	height: 35px;
	position: absolute;
	left: 0;
	bottom: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #fff;
	font-size: 14px;
	background: -webkit-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6));
	background: -moz-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,.6) 100%);
	background: -o-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,.6) 100%);
	background: -ms-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6));
}
.card-bottom{
	padding: 15px 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.card-bottom-l{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.card-bottom-r{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
.card:hover{
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
	cursor: pointer;
	transform: translateY(-10px);
	transition: all .5s;
}
a{
text-decoration:none;
color:#000;
}
a:hover {
color:#000;
}

.p-wrap{
	width: 1200px;
	margin:0 auto;
}
.usercenter-my .el-tabs__item{
	margin-right: 0;
	width:inherit;
	border:none!important;
}
.usercenter-my .el-tabs__item:hover,
.usercenter-my .el-tabs__item.is-active{
  border:none!important;
}
.el-image-viewer__close {
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
}
.el-image-viewer__wrapper .el-icon-circle-close:before{
	color: #fff;
	content: "\e6db";
}
/* 分页样式 */
  .pager-box {
    text-align: center;
    width: 100%;
    margin: 20px auto;
  }

  .el-pager li, .btn-next, .btn-prev {
    padding: 0 4px!important;
    font-size: 13px!important;
    min-width: 35px!important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center!important;
    line-height: 35px!important;
    height: 35px!important;
    margin: 0 5px!important;
    border: 1px solid #b6b6b6!important;
    border-radius: 3px;
    color: #b6b6b6!important;
  }
  .el-pager li:hover,.btn-next:hover,.btn-prev:hover{
	  border: 1px solid $mainColor!important;
      color: $mainColor!important;
  }
  .el-pager li.active,.btn-next.active,.btn-prev.active{
	  background: $mainColor;
      border: 1px solid  $mainColor!important;
      color: #fff!important;
  }
  .el-pager li.active + li,.btn-next.active + li,.btn-prev.active + li{
	  border-left: 1px solid #b6b6b6;
  }
  .lecteachers-pop{
    padding:10px 0!important;
    .lecteachers-list{
      li{
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
      }
    }
  }

.search-box .el-tabs__header{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue